import { Badge } from "@/components/ui/badge";

const MAP = {
  submitted: { label: "Submitted", cls: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300" },
  under_review: { label: "Under Review", cls: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300" },
  revision_required: { label: "Revision Required", cls: "bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950/40 dark:text-orange-300" },
  accepted: { label: "Accepted", cls: "bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-950/40 dark:text-sky-300" },
  proofreading: { label: "Proof-reading", cls: "bg-indigo-50 text-indigo-700 border-indigo-200 dark:bg-indigo-950/40 dark:text-indigo-300" },
  rejected: { label: "Rejected", cls: "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/40 dark:text-red-300" },
  published: { label: "Published", cls: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300" },
  withdrawn: { label: "Withdrawn", cls: "bg-slate-100 text-slate-500 border-slate-200 dark:bg-slate-800 dark:text-slate-400" },
  pending: { label: "Pending", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  completed: { label: "Completed", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export function StatusBadge({ status }) {
  const m = MAP[status] || { label: status, cls: "bg-slate-100 text-slate-700" };
  return <Badge variant="outline" className={`${m.cls} font-medium`} data-testid={`status-${status}`}>{m.label}</Badge>;
}
